export function approximateNumber(number: number): number {
    const numberToString = String(number);

    const approximatedNumber = numberToString.slice(0, Math.min(Math.max(numberToString.length - 1, 1), 2))
        + numberToString.slice(Math.min(Math.max(numberToString.length - 1, 1), 2)).replace(/\d/g, '0') || 0;

    return Number(approximatedNumber);
}
